import React from 'react';
import PropTypes from 'prop-types';

const Basket = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25.83 20.956">
    <path
      d="M19449.623,308.454a2.969,2.969,0,0,1,.338-1.25h-5.67a2.967,2.967,0,0,1,.336,1.25,2.5,2.5,0,1,1-5,0,2.474,2.474,0,0,1,.7-1.729l-2.719-13.9h-3.137a.47.47,0,0,1-.469-.469v-.938a.47.47,0,0,1,.469-.469h3.908a.93.93,0,0,1,.918.757l.342,1.743h7.516a7.73,7.73,0,0,0-.15,1.5c0,.1,0,.215.01.376H19440l1.227,6.251h9.758a7.453,7.453,0,0,0,3.512.874c.092,0,.18,0,.273,0l-.059.264a.932.932,0,0,1-.914.737h-12.205l.373,1.88h11.012a.932.932,0,0,1,.732.347.914.914,0,0,1,.186.791l-.039.186a2.458,2.458,0,0,1,.768,1.8,2.5,2.5,0,0,1-5,0Zm1.563,0a.94.94,0,1,0,.943-.938A.946.946,0,0,0,19451.186,308.454Zm-10,0a.938.938,0,1,0,.938-.938A.941.941,0,0,0,19441.189,308.454Zm7.984-13.128a5.328,5.328,0,1,1,5.328,5.328A5.328,5.328,0,0,1,19449.174,295.327Zm2.232-.6v1.2a.261.261,0,0,0,.26.259h1.977v1.978a.261.261,0,0,0,.26.259h1.2a.26.26,0,0,0,.258-.259v-1.978h1.979a.256.256,0,0,0,.254-.259v-1.2a.256.256,0,0,0-.254-.259h-1.979v-1.973a.26.26,0,0,0-.258-.259h-1.2a.261.261,0,0,0-.26.259v1.973h-1.977A.261.261,0,0,0,19451.406,294.726Z"
      transform="translate(-19434 -289.999)"
      fill={color}
    />
  </svg>
);

Basket.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Basket.defaultProps = {
  width: 25.83,
  height: 20.956,
  color: '#fff',
};

export default Basket;
